import { FC } from "react";

const LoadingArrow: FC = () => {
    return (
        <>
            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4V1.94319C8 1.12982 7.08063 0.656693 6.41876 1.12946L2.13923 4.18627C1.58088 4.58509 1.58088 5.41491 2.13923 5.81373L6.41876 8.87054C7.08063 9.34331 8 8.87018 8 8.05681V6C11.31 6 14 8.69 14 12C14 15.31 11.31 18 8 18C5.02918 18 2.55781 15.833 2.08251 12.9958C1.99126 12.4511 1.55228 12 1 12C0.447715 12 -0.00655379 12.45 0.0615775 12.998C0.552432 16.9466 3.91799 20 8 20C12.42 20 16 16.42 16 12C16 7.58 12.42 4 8 4Z" fill="black"/>
            </svg>
        </>
    )
}

export default LoadingArrow;